class CalendarWidget {
  constructor() {
		this.init();
	}

  eventClickListeners(){
    let editEventForm = this.editEventForm;

    [...document.querySelectorAll('.calendar-new-close-button')].forEach(function(item) {
      item.addEventListener('click', function() {
        document.getElementById('calendar-new').style.display = 'none'
      });
    });

    [...document.querySelectorAll('.calendar-details-close-button')].forEach(function(item) {
      item.addEventListener('click', function() {
        document.getElementById('calendar-details').style.display = 'none'
      });
    });

    document.getElementById('calendar-details-canEdit').addEventListener('click', function(evt){
      editEventForm()
    });

    [...document.querySelectorAll('.calendar-color')].forEach(function(item) {
      item.addEventListener('click', function(e) {
        document.getElementsByClassName('selected')[0].className = document.getElementsByClassName('selected')[0].className.replace('selected', '')

        this.classList.add('selected')
      });
    });
  }

  selectHasValue(select, value) {
    return document.getElementById(select) === null ? false : (document.getElementById(select).innerHTML.indexOf('value="' + value + '"') > -1)
  }

  appendDates(info, type, selectHasValue){
    let dom_start_date = document.getElementById('calendar-new-form-start_date'),
        dom_end_date = document.getElementById('calendar-new-form-end_date'),
        dom_start_time = document.getElementById('calendar-new-form-start_time'),
        dom_end_time = document.getElementById('calendar-new-form-end_time')

    if(type === 'click'){
      let date = new Date(info.date).toLocaleDateString();

      dom_start_date.value = dom_end_date.value = date

      dom_start_time.value = dom_end_time.value = info.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }else if(type === 'drag'){
      let start_date = new Date(info.start).toLocaleDateString(),
          end_date = new Date(info.end);

      end_date.setDate(end_date.getDate() - 1)
      end_date = end_date.toLocaleDateString()

      dom_start_date.value = start_date
      dom_end_date.value = end_date
      dom_start_time.value = info.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      dom_end_time.value = info.end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }

    // hide calendar details
    document.getElementById('calendar-details').style.display = 'none'

    // remove eventId attribute
    document.getElementById('calendar-new').removeAttribute('data-eventId')

    // hide save button
    document.getElementById('calendar-new-button-create').style.display = 'inline-flex'
    document.getElementById('calendar-new-button-save').style.display = 'none'

    // set new calendar modal position
    document.getElementById('calendar-new').style.cssText = 'display:block;left: ' + info.jsEvent.pageX+'px;top: ' + info.jsEvent.pageY+'px';
  }

  editEventForm(){
    fetch('/?calendar-event=' + document.getElementById('calendar-details').getAttribute('data-eventId'))
    .then(response => response.json())
    .then(data => {
      document.getElementById('calendar-new-form-title').value = data.title
      document.getElementById('calendar-new-form-all_day').checked = data.allDay
      document.getElementById('calendar-new-form-name').value = data.name
      document.getElementById('calendar-new-form-note').value = data.note
      document.getElementById('calendar-new-form-location').value = data.location

      if(document.querySelectorAll("[data-color='"+data.color+"']").length){
        document.getElementsByClassName('selected')[0].className = document.getElementsByClassName('selected')[0].className.replace('selected', '')
        document.querySelectorAll("[data-color='"+data.color+"']")[0].classList.add('selected')
      }

      document.getElementById('calendar-new-form-start_date').value = new Date(data.start).toLocaleDateString()
      document.getElementById('calendar-new-form-end_date').value = new Date(data.end).toLocaleDateString()

      document.getElementById('calendar-new-form-start_time').value = new Date(data.start).toLocaleTimeString('sv-SE', { timeStyle: 'short' })
      document.getElementById('calendar-new-form-end_time').value = new Date(data.end).toLocaleTimeString('sv-SE', { timeStyle: 'short' })

      // set eventId attribute
      document.getElementById('calendar-new').setAttribute('data-eventId', data.eventId)

      // hide create button
      document.getElementById('calendar-new-button-save').style.display = 'inline-flex'
      document.getElementById('calendar-new-button-create').style.display = 'none'

      // set new calendar modal position
      document.getElementById('calendar-new').style.cssText = document.getElementById('calendar-details').style.cssText;

      // hide details
      document.getElementById('calendar-details').style.display = 'none'
    });
  }

  eventDetails(info){
    var eventObj = info.event;

    let displayTime = '', displayDate = '', end_date = '', end_time = ''

    let start = new Date(eventObj.start),
        start_date = start.toLocaleDateString('sv-SE', { day: 'numeric', month: 'long', year: 'numeric' }),
        start_time = start.toLocaleTimeString('sv-SE', { timeStyle: 'short' })

    if(eventObj.end){
      let end = new Date(eventObj.end),
          end_date = end.toLocaleDateString('sv-SE', { day: 'numeric', month: 'long', year: 'numeric' }),
          end_time = end.toLocaleTimeString('sv-SE', { timeStyle: 'short' })

      // set time range if needed
      if(start_date === end_date && start_time !== end_time){
        displayTime = start_time + '-' + end_time
      }else{
        displayTime = start_time
      }

      // set date range if needed
      if(start_date !== end_date){
        displayDate = start_date + ' ' + start_time + ' - ' + end_date + ' ' + start_time
        displayTime = ''
      }else{
        displayDate = start_date
      }
    }else{
      if(!eventObj.allDay) displayTime = start_time

      displayDate = start_date
    }

    // make sure to set to empty if all day
    if(eventObj.allDay) displayTime = ''

    // hide calendar new
    document.getElementById('calendar-new').style.display = 'none'

    // set calendar event details modal position
    document.getElementById('calendar-details').style.cssText = 'display:block;left: ' + info.jsEvent.pageX+'px;top: ' + info.jsEvent.pageY+'px';

    // set eventId
    document.getElementById('calendar-details').setAttribute('data-eventId', eventObj.extendedProps.eventId)

    // set modal details
    document.getElementById('calendar-details-title').innerHTML = eventObj.title
    document.getElementById('calendar-details-date').innerHTML = displayDate + ' ' + displayTime

    if(eventObj.backgroundColor){
      document.getElementById('calendar-details-color').style.background = eventObj.backgroundColor
    }else{
      document.getElementById('calendar-details-color').style.background = '#eee'
    }

    if(eventObj.extendedProps.location){
      document.getElementById('calendar-details-location').style.display = 'flex'
      document.getElementById('calendar-details-location').getElementsByTagName('p')[0].innerHTML = eventObj.extendedProps.location
    }else{
      document.getElementById('calendar-details-location').style.display = 'none'
    }

    if(eventObj.extendedProps.note){
      document.getElementById('calendar-details-note').style.display = 'flex'
      document.getElementById('calendar-details-note').getElementsByTagName('p')[0].innerHTML = eventObj.extendedProps.note
    }else{
      document.getElementById('calendar-details-note').style.display = 'none'
    }

    if(eventObj.extendedProps.name){
      document.getElementById('calendar-details-name').style.display = 'flex'
      document.getElementById('calendar-details-name').getElementsByTagName('p')[0].innerHTML = eventObj.extendedProps.name
    }else{
      document.getElementById('calendar-details-name').style.display = 'none'
    }

    if(eventObj.extendedProps.canEdit){
      document.getElementById('calendar-details-canEdit').style.display = 'inline-block'
      document.getElementById('calendar-details-canDelete').style.display = 'inline-block'
    }else{
      document.getElementById('calendar-details-canEdit').style.display = 'none'
      document.getElementById('calendar-details-canDelete').style.display = 'none'
    }
  }

	init(){
    // init event listeners
    this.eventClickListeners()

    function mobileCheck() {
      if (window.innerWidth >= 768 ) {
          return false;
      } else {
          return true;
      }
    };

    // set functions
    let selectHasValue = this.selectHasValue
    let appendDates = this.appendDates
    let eventDetails = this.eventDetails

    document.addEventListener('DOMContentLoaded', () => {

      document.getElementById('calendar-details-canDelete').addEventListener('click', function(evt){
        if(document.getElementById('calendar-details').getAttribute('data-eventId')){
          const data = new FormData();

          data.append('event', JSON.stringify({ eventId: document.getElementById('calendar-details').getAttribute('data-eventId') }))
          data.append('action', 'remove_calendar_event')
          data.append('nonce', main.nonce);

          fetch(variables.ajax_url, {
            method: 'post',
            credentials: 'same-origin',
            body: data
          })
          .then(response => response.json())
          .then(data => {
            document.getElementById('calendar-details').style.display = 'none'
            calendar.refetchEvents();
          });
        }
      });

      document.getElementById('calendar-new-form').addEventListener('submit', function(evt){
        evt.preventDefault();

        let start_date = new Date(document.getElementById('calendar-new-form-start_date').value + ' ' + document.getElementById('calendar-new-form-start_time').value),
            end_date = new Date(document.getElementById('calendar-new-form-end_date').value + ' ' + document.getElementById('calendar-new-form-end_time').value),
            allDay = document.getElementById('calendar-new-form-all_day').checked,
            name = document.getElementById('calendar-new-form-name').value,
            note = document.getElementById('calendar-new-form-note').value,
            location = document.getElementById('calendar-new-form-location').value

        if (!isNaN(start_date.valueOf())) {
          const data = new FormData();

          let eventObj = {
            title: document.getElementById('calendar-new-form-title').value,
            start: start_date,
            color: document.getElementsByClassName('selected')[0].getAttribute('data-color'),
            canEdit: true
          }

          if(end_date) eventObj.end = end_date
          if(allDay) eventObj.allDay = allDay
          if(name) eventObj.name = name
          if(note) eventObj.note = note
          if(location) eventObj.location = location

          if(document.getElementById('calendar-new').getAttribute('data-eventId')){
            eventObj.eventId = document.getElementById('calendar-new').getAttribute('data-eventId')

            data.append('action', 'update_calendar_event')
          }else{
            data.append('action', 'add_calendar_event')
          }

          data.append('event', JSON.stringify(eventObj))
          data.append('nonce', main.nonce);

          fetch(variables.ajax_url, {
            method: 'post',
            credentials: 'same-origin',
            body: data
          })
          .then(res => res.json())
          .then(res => {
            if(document.getElementById('calendar-new').getAttribute('data-eventId')){
              calendar.refetchEvents();
            }else{
              calendar.refetchEvents();
            }
          });
        }
      })

      let calendar = new FullCalendar.Calendar(document.getElementById('calendar'), {
        locale: 'sv',
        firstDay: 1,
        nextDayThreshold: '23:59:59',
        eventTimeFormat: {
          hour: 'numeric',
          minute: '2-digit',
          hour12: false
        },
        themeSystem: 'simplex',
        selectable: true,
        headerToolbar: {
          left: 'title prev today next',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        },
        buttonText: {
          today: 'Idag',
          month: 'Månad',
          week: 'Vecka',
          day: 'Dag',
          list: 'Lista'
        },
        select: (info) => appendDates(info, 'drag', selectHasValue),
        dateClick: (info) => appendDates(info, 'click', selectHasValue),
        eventClick: (info) => eventDetails(info),
        weekNumbers: true,
        weekNumberFormat: { week: 'numeric' },
        dayMaxEvents: true,
        displayEventEnd: true,
        nextDayThreshold: '00:00',
        displayEventTime: true,
        events: '/?calendar-events',
        initialView: window.innerWidth <= 768 ? 'timeGridDay' : 'dayGridMonth',
        windowResize: function(arg) {
          if(window.innerWidth <= 768){
            calendar.changeView('timeGridDay');
          }
        },
        views: {
          timeGridWeek: {
            dayHeaderFormat: { weekday: 'short', day: 'numeric', omitCommas: true },
          }
        }
      });

      calendar.render();
    });
	}
}

export default CalendarWidget;
